import type {CropData} from '@Panels/cropper-panel/cropper-panel.types';

const CROP_NAME_SEPARATOR = '_';
const EXTENSION_SEPARATOR = '.';
const PATH_SEPARATOR = '/';
const URL_SUFFIX_PATTERN = /[?#].*$/;

interface MediaUrlParts {
  directory: string;
  baseName: string;
  extension: string;
}

export function canCropMediaUrl(uncroppedUrl: string): boolean {
  return getMediaUrlParts(uncroppedUrl) !== null;
}

/** Builds the name `CroppedEmailImage::tryFromUrl` parses; null when the source has no file extension. */
export function getCroppedMediaUrl(uncroppedUrl: string, cropData: CropData): string | null {
  const parts = getMediaUrlParts(uncroppedUrl);
  if (!parts) {
    return null;
  }
  return `${parts.directory}${parts.baseName}${CROP_NAME_SEPARATOR}${getCropRectNameSuffix(cropData)}${parts.extension}`;
}

function getMediaUrlParts(url: string): MediaUrlParts | null {
  const path = url.replace(URL_SUFFIX_PATTERN, '');
  const fileNameStart = path.lastIndexOf(PATH_SEPARATOR) + 1;
  const fileName = path.slice(fileNameStart);
  const extensionStart = fileName.lastIndexOf(EXTENSION_SEPARATOR);
  if (extensionStart <= 0 || extensionStart === fileName.length - 1) {
    return null;
  }
  return {
    directory: path.slice(0, fileNameStart),
    baseName: fileName.slice(0, extensionStart),
    extension: fileName.slice(extensionStart),
  };
}

function getCropRectNameSuffix(cropData: CropData): string {
  return [cropData.x, cropData.y, cropData.width, cropData.height].map((value) => Math.round(value)).join(CROP_NAME_SEPARATOR);
}
